(function($) {
    'use strict';

    function Configurator(element, options) {
        this.$element = $(element);
        this.options = $.extend({}, Configurator.defaults, options);
        this.init();
    }

    Configurator.defaults = {
        mode: '3for20',
        basketBlockSelector: '#basket-block',
        addToCartButtonSelector: '.btn-add-to-cart',
        selectedProductsSelector: '.basket-selected-products span',
        basketProgressSelector: '.basket-progress',
        productListSelector: '.promo-3-for-20--content',
        productItemSelector: '.listing__product-has-btn-add-max-3',
        addButtonSelector: '.product-btn--add-3',
        loadMoreButtonSelector: '.promo-3-for-20--content .listing__product-view_all',
        linkPrefix: window.jstransobj ? window.jstransobj.linkPrefix : '',
        cartAddress: window.cart_address || ''
    };

    Configurator.prototype = {
        init: function() {
            this.bindEvents();
            this.updateStatus();
        },

        bindEvents: function() {
            var self = this;

            $(document).on('click', this.options.addButtonSelector + ' .btn-add-3-part', function(e) {
                self.handleProductAction.call(self, $(this));
            });

            $(document).on('click', this.options.basketBlockSelector + ' .btn-add-to-cart.waves-effect', function(e) {
                self.handleAddToCart.call(self);
            });

            $(document).on('click', this.options.loadMoreButtonSelector, function(e) {
                e.preventDefault();
                self.handleLoadMoreProducts.call(self, $(this));
            });
        },

        updateStatus: function(clearBasket) {
            var self = this;
            clearBasket = clearBasket || false;

            $.ajax({
                type: "GET",
                url: this.options.linkPrefix + "/landing/configurator/get/" + this.options.mode + "/status?clearBasket=" + clearBasket,
                success: function(response) {
                    self.updateUI(response);
                }
            });
        },

        updateUI: function(response) {
            var $addToCartButton = $(this.options.basketBlockSelector + ' ' + this.options.addToCartButtonSelector);
            var $basketNumbers = $(this.options.basketBlockSelector + ' ' + this.options.selectedProductsSelector);
            var $basketProgress = $(this.options.basketBlockSelector + ' ' + this.options.basketProgressSelector);

            // Update add to cart button
            if (response.addToCart) {
                $addToCartButton.addClass('waves-effect waves-light green--glow--delay5s');
            } else {
                $addToCartButton.removeClass('waves-effect waves-light green--glow--delay5s');
            }

            // Update basket numbers
            $basketNumbers.html(response.selected + ' / ' + response.maxSelected);

            // Update progress indicators
            this.updateProgressIndicators($basketProgress, response.selected);

            // Update product buttons state
            this.updateProductButtonsState(response);

            // Update product quantities
            this.updateProductQuantities(response.products);
        },

        updateProgressIndicators: function($progress, selected) {
            $progress.find('.bp-item').each(function() {
                $(this).toggleClass('selected', selected > 0);
                selected--;
            });
        },

        updateProductButtonsState: function(response) {
            var $addButtons = $(this.options.productListSelector + ' ' + this.options.addButtonSelector);
            $addButtons.toggleClass('disabled', response.selected === response.maxSelected);
        },

        updateProductQuantities: function(products) {
            var self = this;
            $(this.options.productItemSelector).each(function() {
                var $item = $(this);
                var pid = $item.data('product-id');
                var quantity = products[pid] || 0;

                $item.find(self.options.addButtonSelector + ' .btn-add-3-part.part-quantity').html(quantity);
                $item.toggleClass('product-selected', quantity > 0);
            });
        },

        handleProductAction: function($button) {
            if ($button.parent().hasClass('disabled') && !$button.hasClass('remove')) {
                return;
            }

            var self = this;
            var action = $button.hasClass('remove') ? 'removeProduct' : 'addProduct';
            var $product = $button.parents('.listing__product');
            var pid = $product.data('product-id');

            toggleLoadingAnimation('main .listing__product[data-product-id=' + pid + ']');

            $.ajax({
                type: "GET",
                url: this.options.linkPrefix + "/landing/configurator/get/" + this.options.mode + "/" + action + "?pid=" + pid,
                success: function() {
                    self.updateStatus();
                },
                complete: function() {
                    toggleLoadingAnimation('main .listing__product[data-product-id=' + pid + ']');
                }
            });
        },

        handleAddToCart: function() {
            var self = this;
            toggleLoadingAnimation('basket-block .btn-add-to-cart');

            $.ajax({
                type: "GET",
                url: this.options.linkPrefix + "/landing/configurator/get/" + this.options.mode + "/status",
                success: function(response) {
                    if (response.addToCart) {
                        self.addBundleToCart(response.products);
                    } else {
                        toggleLoadingAnimation('basket-block .btn-add-to-cart');
                    }
                }
            });
        },

        handleLoadMoreProducts: function($button) {
            var self = this;
            var categoryId = null;
            var midCategoryId = null;
            var animationSelector = '.row';
            var parentRow = $button.parents('.row[data-category-id]');
            if(parentRow.length <= 0) {
                parentRow = $button.parents('.small_category_container[data-category-id]');
                animationSelector = '.small_category_container';
            }
            if(parentRow.length > 0) {
                categoryId = parentRow.data('category-id');
                midCategoryId = parentRow.parents('.category-list').data('category-id');
            }


            if(typeof categoryId !== 'undefined' && categoryId !== null && categoryId !== '' && midCategoryId !== null && midCategoryId !== '' && typeof categoryId !== 'undefined') {
                toggleLoadingAnimation('main ' + animationSelector + '[data-category-id=' + categoryId + '] .listing__product-view_all');
                $.ajax({
                    type: "GET",
                    url: this.options.linkPrefix + "/category/smallcat-list/3for20?categoryId=" + midCategoryId + "&smallCategoryId=" + categoryId,
                    success: function(response) {
                        parentRow.replaceWith(response);
                        self.updateStatus();
                    }
                });
            }
        },

        addBundleToCart: function(products) {
            var self = this;
            var date = new Date();
            var productTag = 'three_for_twenty';
            if(this.options.mode === '4for30') {
                productTag = 'four_for_thirty';
            }

            $.ajax({
                url: this.options.cartAddress + this.options.linkPrefix + "/cart/bundle/add",
                method: 'POST',
                data: {
                    products: products,
                    productType: 'product',
                    extraParameters: { product: { tag: productTag, bundleId: date.getTime() } }
                },
                cache: false,
                xhrFields: {
                    withCredentials: true
                },
                success: function(response) {
                    if (typeof getFromCart === 'function') {
                        getFromCart();
                    }
                    if (response.status === 'success') {
                        if (typeof openShoppingCart === 'function') {
                            openShoppingCart();
                        }
                        self.updateStatus(true);
                    }
                },
                complete: function() {
                    toggleLoadingAnimation('basket-block .btn-add-to-cart');
                }
            });
        }
    };

    $.fn.configurator = function(options) {
        return this.each(function() {
            if (!$.data(this, 'configurator')) {
                $.data(this, 'configurator', new Configurator(this, options));
            }
        });
    };
})(jQuery);